<template>
  <vue-plyr ref="plyr" :options="playerOptions">
    <div class="plyr__video-embed">
      <iframe
        :src="getYoutubeUrl"
        allowfullscreen allowtransparency allow="autoplay">
      </iframe>
    </div>
  </vue-plyr>
</template>

<script>
import getIdFromUrl from 'get-youtube-id'

export default {
  props: {
    videoUrl: String,
  },

  computed: {
    videoId() {
      return getIdFromUrl(this.videoUrl)
    },

    getYoutubeUrl() {
      return `https://www.youtube.com/embed/${this.videoId}?iv_load_policy=3&disablekb=0&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`
    },

    getPlayer() {
      return this.$refs.plyr.player
    },

    playerOptions() {
      return {
        controls: ['play', 'progress', 'volume', 'current-time', 'fullscreen']
      }
    }
  }
}
</script>
